import React from 'react';
import { Clock } from 'lucide-react';

export default function PillarComingSoon({ pillar }) {
    if (!pillar) return null;
    const Icon = pillar.icon;

    return (
        <div className="px-4 py-8 text-center">
            <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-stone-100 flex items-center justify-center">
                <Icon className="w-6 h-6 text-stone-400" />
            </div>
            <h3 className="text-sm font-semibold text-stone-700 mb-1" style={{ fontFamily: 'Manrope, sans-serif' }}>
                {pillar.label}
            </h3>
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-amber-50 border border-amber-200 rounded-full mb-3">
                <Clock className="w-3 h-3 text-amber-600" />
                <span className="text-xs font-medium text-amber-700">Coming Soon</span>
            </div>
            {pillar.description && (
                <p className="text-xs text-stone-500 leading-relaxed max-w-[200px] mx-auto">
                    {pillar.description}
                </p>
            )}
        </div>
    );
}
